import { Container, Row, Col } from 'react-grid-system';
import { useScreenClass } from 'react-grid-system';

const Detail = ({
    sourceHeight,
    receiverHeight,
    PathDifference,
    receiverSPLNoBarrier,
    RecieverNoiseLevel,
    barrierAttenuation,
    distanceAttenuation,
    RecieverNoiseLevel2,
    barrierHeight,
    barrierXpos,
    BarrierToRecieverDistance,
    sourceSoundPower,
    frequency,
    measurementDistance,
    sourceNoisePower
}) => {
    const screenClass = useScreenClass();

    return (
        <div className='panel' id="inputsAndOutputs" style={{ marginTop: '40px' }}>
            {console.log(+(Math.round(sourceHeight + "e+1") + "e-1"))}
            <Container >
                <Row id='calculations'>
                    <Col xs={12} sm={6} className='columnsMarginRight'>
                        <h2>
                            Inputs
                        </h2>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Source Height
                            </label>{+(Math.round(sourceHeight + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Receiver Height
                            </label>{+(Math.round(receiverHeight + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Barrier Height
                            </label>{+(Math.round(barrierHeight + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Source/Barrier Distance
                            </label>{+(Math.round(barrierXpos + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Barrier/Reciever Distance
                            </label>{+(Math.round(BarrierToRecieverDistance + "e+2") + "e-2")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>Power(dB)</label>{+(Math.round(sourceSoundPower + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Frequency (Hz)
                            </label>{frequency}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Measurement Distance
                            </label>{+(Math.round(measurementDistance + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            Source Noise Power (dBA){+(Math.round(sourceNoisePower + "e+1") + "e-1")}
                        </div>
                    </Col>
                    <Col xs={12} sm={6} className='columnsMarginLeft' >
                        <h2>
                            Outputs
                        </h2>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Path Difference
                            </label>
                            {+(Math.round(PathDifference + "e+2") + "e-2")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Reciever dB No Barrier
                            </label>
                            {+(Math.round(receiverSPLNoBarrier + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Barrier Attenuation
                            </label>
                            {+(Math.round(barrierAttenuation + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Distance Attenuation
                            </label>
                            {+(Math.round(distanceAttenuation + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px' }}>
                            <label>
                                Reciever Noise Level
                            </label>
                            {+(Math.round(RecieverNoiseLevel + "e+1") + "e-1")}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px', alignItems: 'center' }}>
                            <label>
                                Reciever (w/Distance) Noise Level
                            </label>
                            {+(Math.round(RecieverNoiseLevel2 + "e+1") + "e-1")}
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}



export default Detail
